import React from 'react';
import { Link } from 'react-router-dom';
import useNavigation from '@hooks/useNavigation';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { SupplierNotificationTypeEnum } from '@api/ringil-api.v2';

interface ComponentProps {
  supplierNotificationId: string;
  supplierNotificationAppId?: string;
  supplierNotificationType?: SupplierNotificationTypeEnum;
}

/**
 * Compact "Avizo" badge linking to a supplier notification detail.
 * Keeps the original expedition-list styling (light-orange pill, gray label, orange link).
 */
const SupplierNotificationBadge: React.FC<ComponentProps> = ({
  supplierNotificationId,
  supplierNotificationAppId,
  supplierNotificationType = SupplierNotificationTypeEnum.EFXX,
}) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();

  return (
    <div className="inline-flex items-center px-3 py-1 bg-[#fff5f0] rounded mt-1 w-fit">
      <span className="text-[#616061] mr-[0.35rem] text-sm">{tr('SupplierNotificationBadge.label', 'Avizo')}</span>
      <Link
        className="text-[#ff6b00] no-underline text-sm font-medium hover:underline"
        to={navigation.createNavigationLink(navigation.urlFunctions.createSupplierNotificationDetail(supplierNotificationId, supplierNotificationType))}
      >
        {supplierNotificationAppId}
      </Link>
    </div>
  );
};

export default SupplierNotificationBadge;